export class LiveChatError extends Error {
  public context: Record<string, unknown>;

  constructor(message: string, context: Record<string, unknown> = {}) {
    super(message || 'Unknown LiveChatError');

    this.name = 'LiveChatError';
    this.context = context;

    Object.setPrototypeOf(this, LiveChatError.prototype);
  }
}

export async function isUtagLoaded(): Promise<boolean> {
  if (window.utag) return true;

  const timeout = 15_000;
  const interval = 100;
  const start = Date.now();

  return new Promise((resolve) => {
    const checkUtag = () => {
      if (window.utag) {
        resolve(true);
      } else if (Date.now() - start >= timeout) {
        resolve(false);
      } else {
        setTimeout(checkUtag, interval);
      }
    };
    checkUtag();
  });
}
